module.exports = __webpack_public_path__ + "static/media/home-heart.38c09cee.svg";